/**
 * orga-app-api - veranstaltungen-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Funktionsbereich { 
    admin_benutzer_ids?: Array<string>;
    hat_buchungen?: boolean;
    explizite_freigabe_erforderlich?: boolean;
    funktionsbereich_id: string;
    titel: string;
    vorlage_funktionsbereich_id: string;
    veranstaltung_id: string;
    mandant_id?: string;
    modified_on_utc?: Date;
}

